import { EMobilityWallboxPricesModel, EMobilityWallboxPricesResponse } from '../models/e-mobility-wallbox-models'

export const wallboxPricesToModelTransformer = (response: EMobilityWallboxPricesResponse): EMobilityWallboxPricesModel[] => {
  const data: EMobilityWallboxPricesModel[] = response.id?.map((id, index) => {
    return {
      id: id,
      serialNo: response.serialno[index],
      wallboxId: response.wallboxID[index],
      from: response.from[index],
      to: response.to[index],
      price: response.price[index],
      createdAt: response.createdAt[index],
      updatedAt: response.updatedAt[index],
    }
  })

  return data ?? []
}
